import gql from 'graphql-tag';

import cardElementConfigurationDetails from '../../../../services/cards/graphql/fragments/cardElementConfigurationDetails';

export const cardElementConfigurationCreate = gql`
  mutation cardElementConfigurationCreate(
    $input: CardElementConfigurationCreateInput!
  ) {
    cardElementConfigurationCreate(input: $input) {
      card_element_configuration {
        ...cardElementConfigurationDetails
      }
    }
  }
  ${cardElementConfigurationDetails}
`;

export const cardElementConfigurationUpdate = gql`
  mutation cardElementConfigurationUpdate(
    $input: CardElementConfigurationUpdateInput!
  ) {
    cardElementConfigurationUpdate(input: $input) {
      card_element_configuration {
        ...cardElementConfigurationDetails
      }
    }
  }
  ${cardElementConfigurationDetails}
`;

export const cardElementConfigurationsDelete = gql`
  mutation cardElementConfigurationsDelete(
    $input: CardElementConfigurationsDeleteInput!
  ) {
    cardElementConfigurationsDelete(input: $input) {
      success
    }
  }
`;
